import { createFileRoute, redirect } from "@tanstack/react-router";

import { DatasourceStep } from "~/pages/onboard/steps/datasource-step";
import { activeOrganization$ } from "~/stores/organizations";

/**
 * Datasource onboarding step. First post-company step in the new flow --
 * the user connects (or skips) before they see the paywall. Accepts
 * `"company"` here too so the brief window between `createOrganization`
 * and `setOnboardingCompany` doesn't bounce.
 */
export const Route = createFileRoute("/onboard/datasource")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "done") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const org = activeOrganization$.get();
    if (!org?.id) {
      throw redirect({ to: "/onboard", replace: true });
    }
    if (org.onboarding !== "company" && org.onboarding !== "datasource") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: DatasourceStep,
});
